var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunding(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.0004 12.4998L7.50041 9.9998M10.0004 12.4998C11.1644 12.0571 12.2811 11.4987 13.3337 10.8331M10.0004 12.4998V16.6665C10.0004 16.6665 12.5254 16.2081 13.3337 14.9998C14.2337 13.6498 13.3337 10.8331 13.3337 10.8331M7.50041 9.9998C7.94386 8.84932 8.50224 7.74652 9.16707 6.70813C10.1381 5.15562 11.4901 3.87734 13.0946 2.99488C14.6991 2.11241 16.5026 1.65511 18.3337 1.66647C18.3337 3.93313 17.6837 7.91647 13.3337 10.8331M7.50041 9.9998H3.33374C3.33374 9.9998 3.79207 7.4748 5.00041 6.66647C6.35041 5.76647 9.16707 6.66647 9.16707 6.66647M3.75041 13.7498C2.50041 14.7998 2.08374 17.9165 2.08374 17.9165C2.08374 17.9165 5.20041 17.4998 6.25041 16.2498C6.84207 15.5498 6.83374 14.4748 6.17541 13.8248C5.8515 13.5156 5.42482 13.337 4.97726 13.3232C4.52971 13.3093 4.0928 13.4612 3.75041 13.7498Z",
    stroke: "#141BEB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunding);
export default __webpack_public_path__ + "static/media/funding.b240335d3525be50dfdb7e622e3e0b8c.svg";
export { ForwardRef as ReactComponent };